import { getLocalStorageItem, setLocalStorageItem } from '@palette/helpers/LocalStorageHelper';

import { SESSION_ID } from '@palette/constants/localStorage';

export const getSessionId = () => getLocalStorageItem(SESSION_ID);

export const setSessionId = (sessionId) => setLocalStorageItem(SESSION_ID, sessionId);
